/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'supplyProducts/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_SUPPLY_PRODUCT = `${PATH}TOGGLE_EDIT_SUPPLY_PRODUCT`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

// Global constants for saga
export const SUPPLY_PRODUCTS = {
  CREATE_SUPPLY_PRODUCT: `${PATH}CREATE_SUPPLY_PRODUCT`,
  CREATE_SUPPLY_PRODUCT_SUCCESS: `${PATH}CREATE_SUPPLY_PRODUCT_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_SUPPLY_PRODUCT: `${PATH}DELETE_SUPPLY_PRODUCT`,
  DELETE_SUPPLY_PRODUCT_SUCCESS: `${PATH}DELETE_SUPPLY_PRODUCT_SUCCESS`,
  EDIT_SUPPLY_PRODUCT_SUCCESS: `${PATH}EDIT_SUPPLY_PRODUCT_SUCCESS`,
  EDIT_SUPPLY_PRODUCT: `${PATH}EDIT_SUPPLY_PRODUCT`,
  EXPORT_SUPPLY_PRODUCT: `${PATH}EXPORT_SUPPLY_PRODUCT`,
  EXPORT_SUPPLY_PRODUCT_SUCCESS: `${PATH}EXPORT_SUPPLY_PRODUCT_SUCCESS`,
};

// actions
export const supplyProductsActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_SUPPLY_PRODUCT, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  // api
  getStateFromApi: createAction(SUPPLY_PRODUCTS.GET_STATE_FROM_API),
  createSupplyProduct: createAction(SUPPLY_PRODUCTS.CREATE_SUPPLY_PRODUCT, 'controls'),
  editSupplyProduct: createAction(SUPPLY_PRODUCTS.EDIT_SUPPLY_PRODUCT, 'id', 'controls'),
  deleteSupplyProduct: createAction(SUPPLY_PRODUCTS.DELETE_SUPPLY_PRODUCT, 'id'),

  exportSupplyProducts: createAction(SUPPLY_PRODUCTS.EXPORT_SUPPLY_PRODUCT),
};

const defaultInvalidInputs = {
  name: false,
  unitId: false,
};

const initialState = {
  formControls: {
    name: '',
    unitId: '',
    traceable: false,
  },
  invalidControls: {
    name: false,
    unitId: false,
  },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
};

const supplyProducts = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls.name = '';
    state.formControls.unitId = '';
    state.formControls.traceable = false;
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_SUPPLY_PRODUCT](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.formControls.unitId = action.item.unitId;
    state.formControls.traceable = action.item.traceable;
    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  // api
  [SUPPLY_PRODUCTS.CREATE_SUPPLY_PRODUCT_SUCCESS](state, action) {
    state.formIsOpen = false;
    state.formControls.name = '';
    state.formControls.unitId = '';
    state.formControls.traceable = false;
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [SUPPLY_PRODUCTS.DELETE_SUPPLY_PRODUCT_SUCCESS](state, action) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [SUPPLY_PRODUCTS.EDIT_SUPPLY_PRODUCT_SUCCESS](state, action) {
    state.formControls.name = '';
    state.formControls.unitId = '';
    state.formControls.traceable = false;
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
});

export default supplyProducts;
